export default host => (reelId) => `${host}/reels/${reelId}/downloadZip`